import { SvgSymbol } from '@domgen/base-design-system-2.0/atoms/SvgSymbol/SvgSymbol';

export type ProtectionItem = {
  heading: string;
  text: string;
  highlight: string;
  icon: React.ReactNode;
};

export type HowProtectionWorksContent = {
  title: string;
  protection: ProtectionItem[];
};

export const howProtectionWorksContent = (spritePath: string): HowProtectionWorksContent => {
  return {
    title: 'How extra protection works',
    protection: [
      {
        heading: 'Appliance broken?',
        text: 'Make a claim via My Account or give us a call — { highlight }, ever.',
        highlight: 'no fees',
        icon: (
          <SvgSymbol
            symbol="WashingMachineLeaking"
            className="w-100 h-100 shrink-0"
            spritePath={spritePath}
          />
        ),
      },
      {
        heading: 'On the day of engineer visit...',
        text: `We'll do our best to fix it. If not, you'll get { highlight }.`,
        highlight: 'a replacement',
        icon: (
          <SvgSymbol
            symbol="EngineerVan"
            className="w-100 h-100 shrink-0"
            spritePath={spritePath}
          />
        ),
      },
      {
        heading: 'If you need a new appliance...',
        text: `We'll { highlight }, delivered to your door.`,
        highlight: 'offer similar options',
        icon: (
          <SvgSymbol
            symbol="PersonDollyWashingMachine"
            className="w-100 h-100 shrink-0"
            spritePath={spritePath}
          />
        ),
      },
    ],
  };
};
